import React from 'react'
import PropTypes from 'prop-types'
import lowerCase from 'lodash/lowerCase'
import upperCase from 'lodash/upperCase'
import {useTranslation} from 'react-i18next'
import Tabs from '../Tabs'
import Tab from '../Tab'
import TabPanel from '../TabPanel'
import {confirmAlert} from 'react-confirm-alert'
import {AuditContext} from '../../../context/Audits'
import {UserContext} from '../../../context/User'
import {Dropdown} from 'react-bootstrap'
import ReportModal from '../ReportModal'
import {MapContainer} from '../MapPopup/MapPopup'
import Spinner from 'react-bootstrap/Spinner'
import TableUnlistedItem from './TableUnlistedItem'
import TableAssignedTo from './TableAssignedTo'

import Modal from 'react-bootstrap/Modal'
import ItemPopupContainer from '../ItemPopup/ItemPopupContainer'
import {validateEmail} from '../../../utils/validation'
import {ToastMessageContext} from '../../../context/ToastMessage'
import * as moment from 'moment'

import {AutoSizer, Table, Column, InfiniteLoader} from 'react-virtualized'

function TableTabs({data, itemId}) {
  const {t} = useTranslation()
  const [value, setValue] = React.useState(0)
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [mapAnchorEl, setMapAnchorEl] = React.useState(null)
  const [selectedItem, setSelectedItem] = React.useState(null)
  const [latlng, setLatLng] = React.useState(null)
  // const popupRef = React.createRef()
  const toast = React.useContext(ToastMessageContext)
  //handle popup click
  const handleClick = (event, id) => {
    setAnchorEl(event.currentTarget)
    setSelectedItem(id)
  }
  // handle popup close
  const handleClose = () => {
    setAnchorEl(null)
    setSelectedItem(null)
    document.body.click()
  }

  //handle map popup click
  const handleMapClick = (event, itemId, lat, lng) => {
    setSelectedItem(itemId)
    setMapAnchorEl(event.currentTarget)
    setLatLng({
      lat: lat,
      lng: lng,
    })
  }
  // handle map popup close
  const handleMapClose = () => {
    setLatLng(null)
    setMapAnchorEl(null)
  }

  // const tosterAlertPopup = response => {
  //   if (response !== null && response.status !== 500) {
  //     if (
  //       response.data.errors &&
  //       response.data.errors[0].base &&
  //       response.data.errors[0].base[0] !== undefined
  //     ) {
  //       toast.popMessage(response.data.errors[0].base[0], 'error')
  //     } else {
  //       toast.popMessage('Internal Server Error', 'error')
  //     }
  //   } else {
  //     toast.popMessage('Internal Server Error', 'error')
  //   }
  // }

  const open = itemId || Boolean(anchorEl) ? true : false
  const id = open ? 'item-history-popover' : undefined

  const openMap = Boolean(mapAnchorEl)
  const mapId = openMap ? 'map-popover' : undefined

  const handleChange = newValue => {
    setValue(newValue)
  }
  const {
    audit,
    getReport,
    sendReport,
    getNextItems,
    itemStart,
    setItemStart,
    sortSelectAudit,
    date_format,
  } = React.useContext(AuditContext)
  const user = React.useContext(UserContext)
  const [sendReportInNewEmail, setSendReportInNewEmail] = React.useState(false)
  const [newUserEmail, setNewUserEmail] = React.useState(null)
  const [sendErrorMsg, setSendErroMsg] = React.useState(null)
  const [isInputOpen, setInputOpen] = React.useState(false)
  const [loader, setLoader] = React.useState(false)
  const [loading, setLoading] = React.useState(true)
  const [reportType, setReportType] = React.useState('pdf')
  const [itemSort, setItemSort] = React.useState({
    column_name: 'status',
    sort_by: 'ASC',
  })

  React.useEffect(() => {
    setItemSort({column_name: 'status', sort_by: 'ASC'})
    if (itemId) {
      setSelectedItem(itemId)
    }
  }, [itemId, data.id])

  async function sendReportInInNewEmail(type, close) {
    let email = user.details.email
    if (sendReportInNewEmail) {
      if (newUserEmail === '' || newUserEmail === null || !validateEmail(newUserEmail)) {
        setSendErroMsg('Please enter a valid email')
        return
      } else {
        email = newUserEmail
        setSendErroMsg(null)
        setInputOpen(false)
      }
    }
    const params = {
      id: audit.selected.id,
      account_id: user.details.account_id,
      type: type,
      total_items_count: audit.selected.total_items_count,
      scanned_items_count: audit.selected.scanned_items_count,
      send_email: 'true',
      email: email,
    }
    sendReport(params).then(response => {
      if (response === 'success') {
        toast.popMessage(`Email sent successfully`, 'success')
        close && close()
        setSendReportInNewEmail(false)
        setInputOpen(false)
        setNewUserEmail(null)
      } else {
        // tosterAlertPopup(response)
        toast.popMessage(`Error while sending mail, Please try again later`, 'error')
      }
    })
  }

  const openInputBox = () => {
    setSendReportInNewEmail(true)
    setInputOpen(true)
  }
  const closeInputModal = () => {
    setInputOpen(false)
    setSendReportInNewEmail(false)
    sendAuditConfirmation()
  }

  const getFormattedDate = date => {
    if (date) {
      // return moment(date).format(date_format)
      return date
    } else {
      return null
    }
  }
  const feedNewEmailAdderess = () => event => {
    setNewUserEmail(event.target.value)
  }
  const showReport = (type = 'pdf') => {
    const total_items = audit.selected.total_items_count
    if (total_items > 100) {
      setReportType(type)
      sendAuditConfirmation(type)
    } else {
      const params = {
        id: audit.selected.id,
        account_id: user.details.account_id,
        type: type,
        total_items_count: total_items,
        scanned_items_count: audit.selected.scanned_items_count,
        limit: 100,
      }
      try {
        getReport(params).then(report => {
          if (report.url) {
            window.open(report.response)
          } else {
            setReportType(type)
            sendAuditConfirmation(type)
          }
        })
      } catch (e) {
        console.log(`Genrate Report request failed: ${e}`)
      }
    }
  }

  const sendAuditConfirmation = type => {
    confirmAlert({
      customUI: ({onClose}) => {
        return (
          <div className="audit-div">
            <div className="custom-ui close-modal-custom-ui report-edit m-0">
              <p className="text-center">
                Due to the large data size, this audit report will have to be emailed to you. Is the
                email "{user.details.email}" still correct?
              </p>
              <button
                onClick={() => {
                  openInputBox()
                  onClose()
                }}
                className="mr-1 custom-edit-btn"
              >
                Edit
              </button>
              <button
                onClick={() => {
                  sendReportInInNewEmail(type, onClose)
                }}
                className="custom-send-btn"
              >
                Send
              </button>
            </div>
          </div>
        )
      },
    })
  }

  const handleScroll = e => {
    document.body.click()
  }

  function a11Props(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    }
  }

  const _noRowsRenderer = () => {
    if (loader) {
      return (
        <div className="text_center">
          <Spinner className="audit-spinner mt-15" animation="border" role="status" />
        </div>
      )
    } else {
      return (
        <div className="text_center audit-table__cell--none audit-table__cell--gray audit-table__cell--expand">
          No Records Found
        </div>
      )
    }
  }

  const columnCordinate = row => {
    if (row.id === 'loading') {
      return ''
    }
    return (
      <div
        data-tip={row.latitude !== 0 ? row.latitude + '/' + row.longitude : null}
        data-event="click"
        data-for="map"
        className={row.latitude && row.longitude ? 'cursor_pointer' : ''}
        onClick={event => {
          if (row.latitude && row.longitude) {
            handleMapClick(event, row.id, row.latitude, row.longitude)
          }
        }}
      >
        <span className="cordinateSpan">
          {row.latitude && row.longitude ? row.latitude + ', ' + row.longitude : null}
        </span>
      </div>
    )
  }

  const columnDisplayFieldData = row => {
    if (row.id === 'loading') {
      return <Spinner className="item-spinner mt-15" animation="border" role="status" />
    }
    return (
      <div
        className="cursor_pointer full-width"
        onClick={event => {
          handleClick(event, row.id)
        }}
      >
        <ItemPopupContainer
          className=""
          data={data}
          id={id}
          selectedItem={selectedItem}
          handleClose={handleClose}
          displayField={row.display_field}
          defaultShow={itemId === row.id ? open : false}
          placement="right"
        >
          {row.display_field ? row.display_field : '-'}
        </ItemPopupContainer>
      </div>
    )
  }

  const columnData = (row, column_name, placement, itemClass) => {
    if (row.id === 'loading') {
      return ''
    }
    return (
      <div
        className="cursor_pointer full-width"
        onClick={event => {
          handleClick(event, row.id)
        }}
      >
        <ItemPopupContainer
          className={itemClass}
          data={data}
          id={id}
          selectedItem={selectedItem}
          handleClose={handleClose}
          displayField={row.display_field}
          defaultShow={false}
          placement={placement}
        >
          {getColumnData(row, column_name)}
        </ItemPopupContainer>
      </div>
    )
  }

  const getColumnData = (row, column_name) => {
    if (column_name === 'scanned_by') {
      return row.scanned_by ? row.scanned_by : '-'
    } else if (column_name === 'date_scanned') {
      return row.date_scanned && row.status !== 'not-scanned'
        ? getFormattedDate(row.date_scanned)
        : '-'
    } else if (column_name === 'primary_field') {
      return row.primary_field ? row.primary_field : '-'
    } else if (column_name === 'secondary_field') {
      return row.secondary_field ? row.secondary_field : '-'
    } else if (column_name === 'status') {
      return (
        <div
          className={
            'ap-pillbox ap-pillbox--right ap-pillbox--19' +
            `${
              lowerCase(row.status) === 'scanned' || lowerCase(row.status) === 'manual'
                ? ' ap-pillbox--green'
                : ' ap-pillbox--gray'
            }`
          }
        >
          {upperCase(row.status)}
        </div>
      )
    }
  }

  const _rowClassName = index => {
    if (
      index !== -1 &&
      data.expand_details &&
      selectedItem &&
      data.expand_details.entities_attributes[0].entity_objects[index].id === selectedItem
    ) {
      return 'audit-table__row audit-table__row--no-border-top cursor_pointer audit-table__row--highlighted'
    } else if (
      index !== -1 &&
      data.expand_details.entities_attributes[0].entity_objects[index].id === 'loading'
    ) {
      return 'audit-table__row audit-table__row--no-border-top cursor_pointer loading_row'
    } else {
      return 'audit-table__row audit-table__row--no-border-top cursor_pointer'
    }
  }

  const sortHeader = (data, className = '') => {
    return (
      <div
        className={`audit-icon--sort ${className} ${
          itemSort.column_name === data.dataKey
            ? data.sortDirection === 'ASC'
              ? ' audit-icon--sort-asc'
              : ' audit-icon--sort-desc'
            : ''
        }`}
      >
        <span className="header-overflow-content" title={data.label}>
          {data.label}
        </span>
      </div>
    )
  }

  const _sort = e => {
    setLoader(true)
    let column_name = e.sortBy
    let sort_by = e.sortDirection
    setItemSort({column_name, sort_by})
    sortSelectAudit(data, true, {column_name, sort_by}).then(() => {
      setItemStart(1)
      setLoader(false)
    })
  }

  const loadMore = () => {
    if (loading) {
      setLoading(false)
      getNextItems(data.id, {
        start: itemStart + 1,
        limit: 30,
        entity_id: data.audit_entities_attributes[0].entity_id,
        column_name: itemSort.column_name,
        sort_by: itemSort.sort_by,
      }).then(() => {
        setItemStart(itemStart + 1)
        setLoading(true)
      })
    }
  }

  const getWidth = (width, record) => {
    var actual_width = 0
    if (record.field_names.primary_field === null && record.field_names.secondary_field === null) {
      actual_width = width * 0.625
    } else if (
      record.field_names.primary_field !== null &&
      record.field_names.display_field === record.field_names.primary_field &&
      record.field_names.secondary_field === null
    ) {
      actual_width = width * 0.625
    } else if (
      record.field_names.primary_field !== null &&
      record.field_names.display_field !== record.field_names.primary_field &&
      record.field_names.secondary_field === null
    ) {
      actual_width = width * 0.45
    } else if (
      record.field_names.primary_field !== null &&
      record.field_names.display_field === record.field_names.primary_field &&
      record.field_names.secondary_field !== null
    ) {
      actual_width = width * 0.475
    } else if (
      record.field_names.primary_field !== null &&
      record.field_names.display_field !== record.field_names.primary_field &&
      record.field_names.secondary_field !== null
    ) {
      actual_width = width * 0.3
    }
    if (data.gps_location) {
      actual_width = actual_width - width * 0.15
    }
    return actual_width
  }

  return (
    <div className="audit-expand__column audit-expand__column--table">
      <ReportModal
        isInputOpen={isInputOpen}
        newUserEmail={newUserEmail}
        sendErrorMsg={sendErrorMsg}
        reportType={reportType}
        closeInputModal={closeInputModal}
        feedNewEmailAdderess={feedNewEmailAdderess}
        sendReportInInNewEmail={sendReportInInNewEmail}
      />
      <Tabs
        value={value}
        onChange={(event, newValue) => handleChange(newValue)}
        classes={{root: 'audit-expand__tabs'}}
        defaultactivekey={0}
      >
        {data.audit_entities_attributes.map((entitie, index) => (
          <Tab
            label={entitie.entity_name}
            key={index}
            {...a11Props(index)}
            classes={{root: 'audit-preview__tab--group'}}
          />
        ))}
        <Tab label="Unlisted Items" {...a11Props(1)} classes={{root: 'audit-expand__tab--group'}} />
        <Tab label="Assigned to" {...a11Props(1)} classes={{root: 'audit-expand__tab--group'}} />
      </Tabs>

      <div className="audit-download">
        <Dropdown>
          <Dropdown.Toggle variant="success" id="dropdown-basic" title="Download Reports">
            <span className="dropDown fa fa-download"></span>
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item onClick={() => showReport('pdf')}>Download as PDF</Dropdown.Item>
            <Dropdown.Item onClick={() => showReport('xlsx')}>Download as XLSX</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
      <div className="mt-15">
        {data.expand_details === undefined || data.expand_details === null ? (
          <Spinner animation="border" role="status" />
        ) : (
          <>
            {' '}
            {data.expand_details.entities_attributes.map((record, index) => (
              <TabPanel
                value={value}
                index={index}
                key={index}
                className="audit-expand__section item-table-tab"
              >
                <Modal id={mapId} show={openMap} onClose={handleMapClose}>
                  <MapContainer
                    google={window.google}
                    latlng={latlng}
                    handleClose={handleMapClose}
                  ></MapContainer>
                </Modal>

                {data.expand_details === undefined || data.expand_details === null ? (
                  <div className="text_center">
                    <Spinner className="spinner" animation="border" role="status" />
                  </div>
                ) : (
                  <InfiniteLoader
                    isRowLoaded={({index}) =>
                      !!data.expand_details.entities_attributes[0].entity_objects[index]
                    }
                    loadMoreRows={loadMore}
                    rowCount={data.expand_details.entities_attributes[0].entity_objects_count}
                    threshold={8}
                  >
                    {({onRowsRendered, registerChild}) => (
                      <AutoSizer>
                        {({width}) => (
                          <Table
                            ref={registerChild}
                            onRowsRendered={onRowsRendered}
                            className="audit-table"
                            rowClassName={h => _rowClassName(h.index)}
                            headerHeight={33}
                            onScroll={e => handleScroll(e)}
                            width={width}
                            height={545}
                            rowHeight={38}
                            rowCount={
                              loader
                                ? 0
                                : data.expand_details.entities_attributes[0].entity_objects.length
                            }
                            rowGetter={({index}) =>
                              loader
                                ? []
                                : data.expand_details.entities_attributes[0].entity_objects[index]
                            }
                            rowStyle={{overflow: 'visible'}}
                            sort={e => _sort(e)}
                            sortBy={itemSort.column_name}
                            sortDirection={itemSort.sort_by}
                            noRowsRenderer={_noRowsRenderer}
                          >
                            <Column
                              headerRenderer={h => sortHeader(h)}
                              className="item-table__header overflow-content item-name__cell"
                              cellRenderer={c => columnDisplayFieldData(c.rowData)}
                              label={upperCase(`${record.field_names.display_field}`)}
                              dataKey="display_field"
                              width={getWidth(width, record)}
                            />

                            {record.field_names.primary_field !== null &&
                              record.field_names.display_field !==
                                record.field_names.primary_field && (
                                <Column
                                  headerRenderer={h => sortHeader(h)}
                                  className="item-table__header overflow-content"
                                  cellRenderer={c =>
                                    columnData(c.rowData, 'primary_field', 'right', '')
                                  }
                                  label={upperCase(`${record.field_names.primary_field}`)}
                                  dataKey="primary_field"
                                  width={width * 0.175}
                                />
                              )}

                            {record.field_names.secondary_field !== null && (
                              <Column
                                headerRenderer={h => sortHeader(h)}
                                className="item-table__header overflow-content"
                                cellRenderer={c =>
                                  columnData(c.rowData, 'secondary_field', 'right', '')
                                }
                                label={upperCase(`${record.field_names.secondary_field}`)}
                                dataKey="secondary_field"
                                width={width * 0.15}
                              />
                            )}

                            {data.gps_location && (
                              <Column
                                disableSort={true}
                                headerRenderer={h => upperCase(t('audit.item.current_location'))}
                                className="item-table__header overflow-content"
                                cellRenderer={c => columnCordinate(c.rowData)}
                                label={upperCase(t('audit.item.current_location'))}
                                dataKey="display_field"
                                width={width * 0.15}
                              />
                            )}

                            <Column
                              headerRenderer={h => sortHeader(h)}
                              className="item-table__header overflow-content"
                              cellRenderer={c => columnData(c.rowData, 'date_scanned', 'left', '')}
                              label={upperCase('date_audited')}
                              dataKey="date_scanned"
                              width={width * 0.125}
                            />
                            <Column
                              headerRenderer={h => sortHeader(h)}
                              className="item-table__header overflow-content"
                              cellRenderer={c => columnData(c.rowData, 'scanned_by', 'left', '')}
                              label={upperCase('audited_by')}
                              dataKey="scanned_by"
                              width={width * 0.125}
                            />
                            <Column
                              headerRenderer={h => sortHeader(h, 'audit-table__header--right')}
                              cellRenderer={c =>
                                columnData(c.rowData, 'status', 'left', 'item-history-popup')
                              }
                              className="audit-table__header audit-table__header--right audit-item-tab__cell--right"
                              label={`${upperCase(t('audit.table.columns.status'))} (${
                                data.scanned_items_count
                              }/${data.total_items_count})`}
                              dataKey="status"
                              width={width * 0.125}
                            />
                          </Table>
                        )}
                      </AutoSizer>
                    )}
                  </InfiniteLoader>
                )}
              </TabPanel>
            ))}
            <TabPanel value={value} index={1} className="audit-expand__section">
              {data.custom_records !== undefined && data.custom_records !== null && (
                <div className="unlisted-item-table item-table-tab">
                  <TableUnlistedItem data={data.custom_records} date_format={date_format} />
                </div>
              )}
            </TabPanel>
            <TabPanel value={value} index={2} className="audit-expand__section">
              {data.custom_records !== undefined && data.custom_records !== null && (
                <div className="unlisted-item-table item-table-tab assign-to-table">
                  <TableAssignedTo data={data} />
                </div>
              )}
            </TabPanel>
          </>
        )}
      </div>
    </div>
  )
}

TableTabs.propTypes = {
  audit: PropTypes.shape({}).isRequired,
}

TableTabs.displayName = 'TableTabs'

export default TableTabs
